import { SectionLayout } from "./section-layout";
import { FC } from "react";
import { useAuth } from "react-oidc-context";

export const Root: FC = () => {
  const auth = useAuth();

  // user cancelled sign up
  if (auth.error?.message.includes("AADB2C90091")) {
    // manual refresh to reset auth error
    window.location.reload();
  }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SectionLayout />
      </div>
    );
};
